export const DW_AUTO_REFRESH_STORAGE_KEY = 'dwRequestAutoRefresh';
